import type { z } from 'zod';

import { logError } from '~/common/utils/log';

// Codes and path shapes only: never the values, which can hold secrets or PII.
export const summarizeZodIssues = (error: z.ZodError) => ({
  issues: error.issues.map((issue) => ({
    code: issue.code,
    path: issue.path.map((segment) => (typeof segment === 'number' ? '[index]' : '[field]')),
  })),
});

export const parseOrLog = <T extends z.ZodTypeAny>(
  schema: T,
  data: unknown,
  context: string
): z.output<T> => {
  const parsed = schema.safeParse(data);
  if (parsed.success === false) {
    logError(`${context}: unexpected response body`, summarizeZodIssues(parsed.error));
    throw parsed.error;
  }
  return parsed.data;
};
